import axios from "axios";
import authService from "./authService";

const urlApiWeb = "https://jamii.caltec.mx/";
const urlLocal = "http://127.0.0.1:8000";

const isLocal = false;

const instance = axios.create({
  baseURL: isLocal ? urlLocal : urlApiWeb,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

instance.interceptors.request.use(
  async (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.authorization = `Token ${token}`;
    }
    return config;
  },
  (err) => {
    Promise.reject(err);
  }
);

export default instance;
